module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/section02_08_american-village-46bb4abea250963457e147725f253061.jpg";